module.exports = __webpack_public_path__ + "static/media/co_interfaz.9721f006.png";